export class ScopedApiKeysUtils {
  // Note: here we need to define all searchable resources - or we expect all of them to be so but backend already stated some will be without
  public static readonly searchableResourceTypes = ['EdgeScript', 'VideoLibrary'];

  public static isResourceSearchable(product: string): boolean {
    return ScopedApiKeysUtils.searchableResourceTypes.includes(product);
  }

  // 'EdgeScript' → 'Edge Script'
  public static formatProductLabel(product: string): string {
    const spaced = product.replace(/([a-z])([A-Z])/g, '$1 $2');

    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
  }
}
